import {
  Circle as BaseCircle,
  CircleF as BaseCircleF,
  Marker as BaseMarker,
  MarkerF as BaseMarkerF,
  Polygon as BasePolygon,
  PolygonF as BasePolygonF,
  Polyline as BasePolyline,
  PolylineF as BasePolylineF,
  Rectangle as BaseRectangle,
  RectangleF as BaseRectangleF,
} from "@react-google-maps/api";
import { useResolvedColors } from "./useResolvedColors";

type MapShapeProps = { options?: unknown; icon?: unknown };

const withResolvedColors = <P extends MapShapeProps,>(Component: (props: P) => JSX.Element | null) => {
  const Themed = (props: P) => {
    const options = useResolvedColors(props.options);
    const icon = useResolvedColors(props.icon);
    return <Component {...props} options={options} icon={icon} />;
  };
  Themed.displayName = `Themed(${(Component as { displayName?: string; name?: string }).displayName ?? "MapShape"})`;
  return Themed;
};

export const Circle = withResolvedColors(BaseCircle as never);
export const Marker = withResolvedColors(BaseMarker as never);
export const Polygon = withResolvedColors(BasePolygon as never);
export const Polyline = withResolvedColors(BasePolyline as never);
export const Rectangle = withResolvedColors(BaseRectangle as never);
export const CircleF = withResolvedColors(BaseCircleF as never);
export const MarkerF = withResolvedColors(BaseMarkerF as never);
export const PolygonF = withResolvedColors(BasePolygonF as never);
export const PolylineF = withResolvedColors(BasePolylineF as never);
export const RectangleF = withResolvedColors(BaseRectangleF as never);
